import { render } from "./langTranslate.vue?vue&type=template&id=b2ec88c8&lang=html"
import script from "./langTranslate.vue?vue&type=script&lang=js"
export * from "./langTranslate.vue?vue&type=script&lang=js"

import "./langTranslate.vue?vue&type=style&index=0&id=b2ec88c8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__